import React, {Component} from 'react';
import {Col, Label, FormGroup, Modal, ModalBody, ModalHeader, Form, Button, ModalFooter} from "reactstrap";
import Select from "../../../local_node_modules/react-select";
import {request} from "../../../helper/APIUtils";
import {showAxiosError} from "../../../helper/helper";
import ReactLoading from "react-loading";
import Alert from "react-s-alert";

class UserCompanyDefinitionModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userDefinition: {},
            isLoading: false,
            profileIds: [],
            docType: "EFATURA",
            documentProfile: null
        }
        this.fetchUserDefinitionValue = this.fetchUserDefinitionValue.bind(this);
        this.filterScenarioOptions = this.filterScenarioOptions.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.getDefaultValues = this.getDefaultValues.bind(this);
        this.saveClicked = this.saveClicked.bind(this);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps.userDefinition !== this.props.userDefinition){
            this.setState({userDefinition: nextProps.userDefinition})
        }
    }

    componentWillMount() {
        this.getDefaultValues();
        this.fetchUserDefinitionValue();
    }

    getDefaultValues() {
        let params = {
            url: `/customer/getDefaultValues`,
            method: "get",
        };
        return request(params)
            .then(response => {
                let data = response.data;
                this.setState({profileIds: data.profileIds});
            })
            .catch(function (error) {
                showAxiosError(error);
            });
    }


    fetchUserDefinitionValue() {
        let self = this;
        let docType= self.state.docType;
        let documentProfile = self.state.documentProfile;
        let params = {
            url: `/customer/getUserDefinition?docType=${docType}`,
            method: "get"
        };
        self.setState({isLoading: true});
        request(params)
            .then(function (response) {
                if(response.data !== null){
                    documentProfile = response.data.documentProfile;
                }
                self.setState({userDefinition: response.data, isLoading: false, documentProfile})
            }).catch(function (error) {
            self.setState({isLoading: false});
            showAxiosError(error);

        });
    }

    filterScenarioOptions() {
        if (this.state.docType === "EBELGE") {
            return [{
                value: "EBELGE",
                label: "EBELGE"
            }]
        }

        let profileIds = (this.state.docType === "EARSIVFATURA") ?
            this.state.profileIds.filter(item => item.shortName === "EARSIVFATURA") :
            this.state.profileIds.filter(item => item.shortName !== "EARSIVFATURA");

        return profileIds.map(profileId => ({
            value: profileId.shortName,
            label: profileId.longName
        }));

    }

    onChangeSelect(value, name) {
        let {documentProfile, docType} = this.state;
        if (name === "documentProfile") {
            documentProfile = value;
        }

        if (name === "docType") {
            docType = value;
        }
        this.setState({documentProfile, docType})
    }

    saveClicked() {
        let self = this;
        let {documentProfile, docType} = self.state;
        let userDefinition = self.state.userDefinition ? self.state.userDefinition :
            {docType: "",
            documentProfile: ""};
        userDefinition.documentProfile = documentProfile;
        userDefinition.docType = docType;
        let params = {
            url: '/customer/saveUserDefinition',
            method: "post",
            data : userDefinition
        };
        self.setState({isLoading: true});
        request(params)
            .then(function (response) {
                if (response.data) {
                    Alert.success("Kaydetme işlemi başarılı.", {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 2000
                    });
                    self.setState({isLoading: false});
                    self.props.toggle(response.data);
                }
            }).catch(function (error) {
            showAxiosError(error);
            self.setState({isLoading: false});
        });
    }


    render() {
        const docTypes = [
            {value: "EFATURA", label: "E-Fatura"}
        ];

        return (
            <Modal isOpen={this.props.isOpen} size={"lg"}>
                <ModalHeader toggle={this.props.toggle}>Varsayılan Bilgiler Tanım İşlemleri</ModalHeader>
                <ModalBody style={{paddingTop: "5px"}}>
                    <div>
                        {this.state.isLoading && <ReactLoading type="spinningBubbles" style={{
                            width: "70px",
                            height: "70px",
                            margin: "10px auto 10px auto",
                            fill: "#888"
                        }}/>
                        }
                        {!this.state.isLoading &&
                            <Form>
                                <Label sm={12} style={{
                                    fontWeight: 'bold',
                                    color: "red",
                                    fontSize: "16px",
                                    paddingBottom: "35px"
                                }}
                                >Varsayılan Belge Bilgilerim</Label>
                                <Col sm="12">
                                    <FormGroup row>
                                        <Label sm={4}>Belge Türü: </Label>
                                        <Col sm={4}>
                                            <Select id="docType" name={"docType"}
                                                    value={this.state.docType ? this.state.docType : ""}
                                                    clearable={false}
                                                    disabled={true}
                                                    onChange={e => {
                                                        this.onChangeSelect(e.value, "docType");
                                                    }}
                                                    options={docTypes}/>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label sm={4}>Senaryo Türü: </Label>
                                        <Col sm={4}>
                                            <Select id="documentProfile" name={"documentProfile"}
                                                    value={this.state.documentProfile}
                                                    clearable={false}
                                                    placeholder="Seçiniz..."
                                                    onChange={e => {
                                                        this.onChangeSelect(e.value, "documentProfile");
                                                    }}
                                                    options={this.filterScenarioOptions()}/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                            </Form>
                        }
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button style={{paddingLeft: '16px', width: '100px'}} color="secondary" onClick={()=>this.props.toggle()}>
                        Kapat
                    </Button>
                    <Button style={{paddingLeft: '16px', width: '100px'}} disabled={this.state.isLoading} color="success" onClick={this.saveClicked}>
                        Kaydet
                    </Button>
                </ModalFooter>
            </Modal>

        );
    }
}

export default UserCompanyDefinitionModal;